export default "__VITE_ASSET__ff87293e__"